(() => {
  "use strict";

  if (window.__ONLYDREAM_LOOKBOOK_2026__) return;
  window.__ONLYDREAM_LOOKBOOK_2026__ = true;

  const BUTTON_SELECTOR = "[data-look-add]";
  const CART_DRAWER_SELECTOR = "#CartDrawer";
  const DRAWER_OPENER_SELECTOR =
    '[data-sidebar-button][data-sidebar-id="CartDrawer"]';
  const SHEET_ID = "LookbookSizeSheet";
  const DEFAULT_ERROR = "Non è stato possibile aggiungere il look al carrello.";

  let activeButton = null;
  let activeData = null;
  let selections = [];

  /* ---------- Utility ---------- */

  function getRoot() {
    return window.Shopify?.routes?.root || "/";
  }

  function getCartAddUrl() {
    return window.routes?.cart_add_url || `${getRoot()}cart/add.js`;
  }

  function formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || "EUR";
    return new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency
    }).format((Number(cents) || 0) / 100);
  }

  function el(tag, attrs = {}, children = []) {
    const node = document.createElement(tag);
    for (const [key, value] of Object.entries(attrs)) {
      if (value === false || value == null) continue;
      if (key === "text") node.textContent = value;
      else if (key === "class") node.className = value;
      else node.setAttribute(key, value === true ? "" : value);
    }
    for (const child of [].concat(children)) {
      if (child) node.append(child);
    }
    return node;
  }

  function readLookData(button) {
    const script = button
      .closest("[data-look-card]")
      ?.querySelector("[data-look-json]");
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.error("[Lookbook 2026] JSON del look non valido", error);
      return null;
    }
  }

  /* ---------- Feedback sulla card ---------- */

  function setFeedback(button, message = "", status = "") {
    const feedback = button
      ?.closest("[data-look-card]")
      ?.querySelector("[data-look-feedback]");
    if (!feedback) return;
    feedback.textContent = message;
    if (status) feedback.dataset.status = status;
    else delete feedback.dataset.status;
  }

  function showGlobalNotification(message, type = "warning") {
    const bodyElement = document.querySelector("body-element");
    if (typeof bodyElement?.showNotification === "function") {
      bodyElement.showNotification(message, type);
    }
  }

  function getErrorMessage(payload) {
    const description =
      payload?.description || payload?.message || payload?.errors || DEFAULT_ERROR;
    if (description && typeof description === "object") {
      return Object.entries(description)
        .map(([key, value]) => `${key}: ${value}`)
        .join(", ");
    }
    return String(description);
  }

  /* ---------- Carrello (invariato rispetto alla versione precedente) ---------- */

  async function postItems(variantIds, cartSectionId) {
    const payload = {
      items: variantIds.map((id) => ({ id, quantity: 1 }))
    };

    if (cartSectionId) {
      payload.sections = [cartSectionId];
      payload.sections_url = window.location.pathname;
    }

    const response = await fetch(getCartAddUrl(), {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify(payload)
    });

    const responseText = await response.text();
    let data;
    try {
      data = JSON.parse(responseText);
    } catch {
      data = { message: "Il carrello ha restituito una risposta non valida." };
    }

    if (!response.ok) {
      const cartError = new Error(getErrorMessage(data));
      cartError.status = response.status;
      cartError.payload = data;
      throw cartError;
    }

    return data;
  }

  function createAuroraState(responseData, addedCount) {
    const firstItem = responseData?.items?.[0] || responseData || {};
    return {
      ...firstItem,
      quantity: Number(firstItem.quantity) || addedCount,
      items: responseData?.items || []
    };
  }

  async function updateAuroraDrawer(responseData, addedCount) {
    const cartDrawer = document.querySelector(CART_DRAWER_SELECTOR);
    const cartSectionId = cartDrawer?.dataset?.sectionId || "";
    const sectionHTML = cartSectionId
      ? responseData?.sections?.[cartSectionId]
      : "";

    if (
      cartDrawer &&
      sectionHTML &&
      typeof cartDrawer.purchaseHandler === "function"
    ) {
      const parsedHTML = new DOMParser().parseFromString(sectionHTML, "text/html");
      const auroraState = createAuroraState(responseData, addedCount);
      cartDrawer.updateAsideProductsByParsedState?.(auroraState);
      cartDrawer.updateEmptyStatus?.();
      await cartDrawer.purchaseHandler(parsedHTML, auroraState);
      return true;
    }

    const opener = document.querySelector(DRAWER_OPENER_SELECTOR);
    if (opener) {
      opener.click();
      return true;
    }
    return false;
  }

  async function addItemsSeparately(variantIds, cartSectionId) {
    const successfulIds = [];
    let latestResponse = null;

    for (const variantId of variantIds) {
      try {
        latestResponse = await postItems([variantId], cartSectionId);
        successfulIds.push(variantId);
      } catch (error) {
        console.warn("[Lookbook 2026] Taglia saltata", {
          variantId,
          status: error.status,
          message: error.message
        });
      }
    }

    return { successfulIds, latestResponse };
  }

  /* ---------- Pannello taglie ---------- */

  function getSheet() {
    let sheet = document.getElementById(SHEET_ID);
    if (sheet) return sheet;

    sheet = el("dialog", {
      id: SHEET_ID,
      class: "lb-sheet",
      "aria-labelledby": `${SHEET_ID}Title`
    }, [
      el("div", { class: "lb-sheet__panel" }, [
        el("div", { class: "lb-sheet__head" }, [
          el("h2", { id: `${SHEET_ID}Title`, class: "lb-sheet__title" }),
          el("button", {
            type: "button",
            class: "lb-sheet__close",
            "aria-label": "Chiudi",
            "data-sheet-close": true,
            text: "×"
          })
        ]),
        el("div", { class: "lb-sheet__items", "data-sheet-items": true }),
        el("div", { class: "lb-sheet__foot" }, [
          el("div", { class: "lb-sheet__total" }, [
            el("span", { text: "Totale" }),
            el("strong", { "data-sheet-total": true })
          ]),
          el("button", {
            type: "button",
            class: "lb-sheet__cta",
            "data-sheet-cta": true
          }),
          el("p", {
            class: "lb-sheet__status",
            role: "status",
            "aria-live": "polite",
            "data-sheet-status": true
          })
        ])
      ])
    ]);

    sheet.addEventListener("click", (event) => {
      if (event.target === sheet || event.target.closest("[data-sheet-close]")) {
        closeSheet();
      }
    });

    sheet.addEventListener("close", () => {
      document.documentElement.classList.remove("lb-sheet-open");
      activeButton?.focus({ preventScroll: true });
    });

    sheet.addEventListener("change", (event) => {
      const input = event.target.closest("input[data-item-index]");
      if (!input) return;
      const index = Number(input.dataset.itemIndex);
      selections[index] = activeData.items[index].variants.find(
        (variant) => String(variant.id) === input.value
      ) || null;
      updateFooter();
    });

    sheet.querySelector("[data-sheet-cta]").addEventListener("click", submitSheet);

    document.body.append(sheet);
    return sheet;
  }

  function renderItem(item, index) {
    const available = item.variants.filter((variant) => variant.available);
    const autoSelected = available.length === 1 ? available[0] : null;
    selections[index] = autoSelected;

    const sizes = el("div", {
      class: "lb-sheet__sizes",
      role: "radiogroup",
      "aria-label": `Taglia per ${item.title}`
    });

    item.variants.forEach((variant) => {
      const inputId = `${SHEET_ID}-${index}-${variant.id}`;
      sizes.append(
        el("input", {
          type: "radio",
          class: "lb-sheet__radio",
          id: inputId,
          name: `${SHEET_ID}-item-${index}`,
          value: String(variant.id),
          "data-item-index": String(index),
          disabled: !variant.available,
          checked: autoSelected?.id === variant.id
        }),
        el("label", {
          class: "lb-sheet__size",
          for: inputId,
          text: variant.size,
          "aria-label": variant.available
            ? variant.size
            : `${variant.size}, esaurita`
        })
      );
    });

    const priceVariant = autoSelected || available[0] || item.variants[0];

    return el("div", { class: "lb-sheet__item" }, [
      item.image
        ? el("img", {
            class: "lb-sheet__image",
            src: item.image,
            alt: "",
            width: "72",
            height: "90",
            loading: "lazy"
          })
        : el("div", { class: "lb-sheet__image" }),
      el("div", { class: "lb-sheet__info" }, [
        el("a", { class: "lb-sheet__name", href: item.url, text: item.title }),
        el("p", {
          class: "lb-sheet__meta",
          text: [item.color, formatMoney(priceVariant?.price)]
            .filter(Boolean)
            .join(" — ")
        }),
        sizes
      ])
    ]);
  }

  function updateFooter() {
    const sheet = getSheet();
    const cta = sheet.querySelector("[data-sheet-cta]");
    const totalEl = sheet.querySelector("[data-sheet-total]");
    const missing = selections.filter((selection) => !selection).length;

    const total = activeData.items.reduce((sum, item, index) => {
      const variant =
        selections[index] ||
        item.variants.find((v) => v.available) ||
        item.variants[0];
      return sum + (Number(variant?.price) || 0);
    }, 0);

    totalEl.textContent = formatMoney(total);

    if (missing > 0) {
      cta.disabled = true;
      cta.textContent =
        missing === 1
          ? "Scegli la taglia mancante"
          : `Scegli le taglie (${missing} capi)`;
    } else {
      cta.disabled = false;
      cta.textContent = "Aggiungi al carrello";
    }
  }

  function openSheet(button) {
    const data = readLookData(button);
    if (!data?.items?.length) {
      setFeedback(button, "Nessun capo disponibile per questo look.", "error");
      return;
    }

    activeButton = button;
    activeData = data;
    selections = [];

    const sheet = getSheet();
    sheet.querySelector(`#${SHEET_ID}Title`).textContent = data.title || "Il look";
    sheet.querySelector("[data-sheet-status]").textContent = "";

    const list = sheet.querySelector("[data-sheet-items]");
    list.replaceChildren(...data.items.map(renderItem));

    updateFooter();
    setFeedback(button);

    document.documentElement.classList.add("lb-sheet-open");
    sheet.showModal();
  }

  function closeSheet() {
    const sheet = document.getElementById(SHEET_ID);
    if (sheet?.open) sheet.close();
  }

  async function submitSheet() {
    const sheet = getSheet();
    const cta = sheet.querySelector("[data-sheet-cta]");
    const status = sheet.querySelector("[data-sheet-status]");
    const button = activeButton;

    if (cta.disabled || selections.some((selection) => !selection)) return;

    const variantIds = [...new Set(selections.map((selection) => Number(selection.id)))];
    const cartSectionId =
      document.querySelector(CART_DRAWER_SELECTOR)?.dataset?.sectionId || "";

    cta.disabled = true;
    cta.setAttribute("aria-busy", "true");
    cta.textContent = "Aggiungo il look…";
    status.textContent = "";

    try {
      let responseData;
      let addedCount = variantIds.length;

      try {
        responseData = await postItems(variantIds, cartSectionId);
      } catch (error) {
        if (error.status !== 422) throw error;

        // Una taglia si è esaurita nel frattempo: aggiungo le altre una per una.
        const fallback = await addItemsSeparately(variantIds, cartSectionId);
        if (!fallback.successfulIds.length || !fallback.latestResponse) throw error;

        responseData = fallback.latestResponse;
        addedCount = fallback.successfulIds.length;

        const message =
          `Aggiunti ${addedCount} capi su ${variantIds.length}. ` +
          "Una taglia scelta si è appena esaurita.";
        setFeedback(button, message, "warning");
        showGlobalNotification(message);
      }

      closeSheet();
      await updateAuroraDrawer(responseData, addedCount);

      if (addedCount === variantIds.length) {
        setFeedback(button, `${addedCount} capi aggiunti al carrello.`, "success");
      }
    } catch (error) {
      console.error("[Lookbook 2026]", error);
      status.textContent = error?.message || DEFAULT_ERROR;
      updateFooter();
    } finally {
      cta.removeAttribute("aria-busy");
    }
  }

  /* ---------- Stili ---------- */

  function ensureStyles() {
    if (document.getElementById("Lookbook2026ScriptStyles")) return;

    const style = document.createElement("style");
    style.id = "Lookbook2026ScriptStyles";
    style.textContent = `
      .lookbook-card__feedback { margin: 10px 0 0; font-size: 0.875rem; line-height: 1.4; }
      .lookbook-card__feedback:empty { display: none; }
      .lookbook-card__feedback[data-status="success"] { color: var(--gsc-success-color, currentColor); }
      .lookbook-card__feedback[data-status="warning"],
      .lookbook-card__feedback[data-status="error"] { color: var(--gsc-error-color, currentColor); }

      html.lb-sheet-open { overflow: hidden; }

      .lb-sheet {
        width: 100%; max-width: 520px; max-height: 88vh;
        margin: auto auto 0; padding: 0; border: 0;
        border-radius: 22px 22px 0 0; background: #fff; color: #171717;
        font-family: 'Inter', Arial, Helvetica, sans-serif;
      }
      .lb-sheet::backdrop { background: rgba(0, 0, 0, 0.45); }
      .lb-sheet[open] { animation: lb-sheet-up 260ms cubic-bezier(0.2, 0.7, 0.3, 1); }
      @keyframes lb-sheet-up { from { transform: translateY(100%); } to { transform: none; } }

      .lb-sheet__panel { display: flex; flex-direction: column; max-height: 88vh; }
      .lb-sheet__head {
        display: flex; align-items: center; justify-content: space-between; gap: 16px;
        padding: 20px 22px 14px; border-bottom: 1px solid rgba(23, 23, 23, 0.13);
      }
      .lb-sheet__title {
        margin: 0; font-family: 'Ibarra Real Nova', Georgia, serif !important;
        font-size: 26px !important; font-weight: 500 !important; line-height: 1.1 !important;
      }
      .lb-sheet__close {
        width: 40px; height: 40px; flex: 0 0 40px; border: 0; border-radius: 50%;
        background: #f7f6f3; color: #171717; font-size: 24px; line-height: 1; cursor: pointer;
      }

      .lb-sheet__items { overflow-y: auto; padding: 4px 22px; }
      .lb-sheet__item {
        display: grid; grid-template-columns: 72px minmax(0, 1fr); gap: 14px;
        padding: 16px 0; border-bottom: 1px solid rgba(23, 23, 23, 0.13);
      }
      .lb-sheet__item:last-child { border-bottom: 0; }
      .lb-sheet__image {
        width: 72px; height: 90px; object-fit: cover; border-radius: 10px; background: #f7f6f3;
      }
      .lb-sheet__name { font-size: 15px; font-weight: 600; color: inherit; text-decoration: none; }
      .lb-sheet__name:hover { text-decoration: underline; }
      .lb-sheet__meta { margin: 4px 0 10px; font-size: 13px; color: rgba(23, 23, 23, 0.68); }

      .lb-sheet__sizes { display: flex; flex-wrap: wrap; gap: 8px; }
      .lb-sheet__radio { position: absolute; opacity: 0; pointer-events: none; }
      .lb-sheet__size {
        min-width: 44px; min-height: 40px; padding: 9px 12px;
        display: inline-flex; align-items: center; justify-content: center;
        border: 1px solid rgba(23, 23, 23, 0.25); border-radius: 999px;
        font-size: 14px; font-weight: 500; cursor: pointer;
      }
      .lb-sheet__radio:checked + .lb-sheet__size { background: #171717; border-color: #171717; color: #fff; }
      .lb-sheet__radio:focus-visible + .lb-sheet__size { outline: 2px solid #171717; outline-offset: 2px; }
      .lb-sheet__radio:disabled + .lb-sheet__size {
        cursor: not-allowed; color: rgba(23, 23, 23, 0.35); text-decoration: line-through;
        border-style: dashed;
      }

      .lb-sheet__foot {
        padding: 14px 22px calc(18px + env(safe-area-inset-bottom, 0px));
        border-top: 1px solid rgba(23, 23, 23, 0.13);
      }
      .lb-sheet__total {
        display: flex; justify-content: space-between; align-items: baseline;
        margin-bottom: 12px; font-size: 14px;
      }
      .lb-sheet__total strong { font-family: 'Ibarra Real Nova', Georgia, serif; font-size: 24px; }
      .lb-sheet__cta {
        width: 100%; min-height: 54px; border: 0; border-radius: 999px;
        background: #171717; color: #fff; font-size: 15px; font-weight: 600; cursor: pointer;
      }
      .lb-sheet__cta:disabled { opacity: 0.42; cursor: not-allowed; }
      .lb-sheet__status { margin: 10px 0 0; font-size: 13px; color: var(--gsc-error-color, #b00020); }
      .lb-sheet__status:empty { display: none; }

      @media (min-width: 750px) {
        .lb-sheet { margin: auto; border-radius: 22px; }
        .lb-sheet[open] { animation: lb-sheet-fade 200ms ease; }
        @keyframes lb-sheet-fade { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: none; } }
      }

      @media (prefers-reduced-motion: reduce) {
        .lb-sheet[open] { animation: none; }
      }
    `;
    document.head.appendChild(style);
  }

  ensureStyles();

  document.addEventListener("click", (event) => {
    const button = event.target.closest(BUTTON_SELECTOR);
    if (!button) return;
    event.preventDefault();
    openSheet(button);
  });
})();